export default __webpack_public_path__ + "static/media/GUY.50377710.svg";